<template>
  <div id="designs-modal" class="modal darker" @click.self="closeModal()">
    <div class="modal-container">
      <div class="header">
        <p>All available designs</p>
        <CloseButton @close="closeModal()" />
      </div>
      <div class="designs-container">
        <div
          class="product-container"
          v-for="(designName, index) in designs"
          :key="index + 'd-m'"
        >
          <div class="product-wrapper">
            <Product
              :product="designsModalProduct"
              :originalProduct="designsModalProduct"
              :designName="designName"
              :withDescription="false"
              :productIsCustomizable="true"
              :withProductGrid="false"
              :withImage="true"
              :hideInfo="true"
              :isPreviewMode="true"
              :isPlaybookDesignPage="true"
            />
            <p>{{ designName }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseButton from "@/components/Utils/CloseButton.vue";
import Product from "@/components/Projects/Product/Product.vue";

import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "DesignsModal",

  computed: {
    ...mapState("project", ["designsModalProduct"]),
    ...mapGetters("catalog", ["getProductCatalogData"]),
    ...mapGetters("threekit", ["getProductByStyleName"]),

    designs() {
      if (!this.designsModalProduct) return [];

      return this.designsModalProduct?.threekit_designs?.map(
        (d) => d?.design_name
      );
    },

    productData() {
      return this.getProductCatalogData(this.designsModalProduct?.styleId);
    },

    threekitProductData() {
      return this.getProductByStyleName(this.designsModalProduct?.styleId);
    },
  },

  methods: {
    ...mapActions("project", ["setDesignsModalProduct"]),
    ...mapActions("threekit", ["initProductCache"]),

    closeModal() {
      this.setDesignsModalProduct(null);
    },
  },

  components: {
    CloseButton,
    Product,
  },
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  background-color: rgba(40, 42, 48, 0.08);
  margin-bottom: 0 !important;
  z-index: 100;

  &.above-all {
    position: fixed;
  }

  &.darker {
    background-color: #26262c52;
  }

  .modal-container {
    width: 80%;
    max-width: 1366px;
    height: 90vh;
    margin: 3% auto;
    background: white;
    border-radius: 6px;
    box-shadow: 0px 3px 6px -3px #00000036;
    overflow-y: scroll;
    position: relative;

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1.2rem;
      border-bottom: 1px solid $grey-light;

      top: 0;
      position: sticky;
      background: white;
      z-index: 100;
      p {
        text-transform: capitalize;
        margin-right: auto;
        margin-left: 0.5rem;
      }
    }

    .content {
      display: flex;
      flex-flow: column;
      padding: 1.3rem 1.5rem;
      p.text {
        color: $grey-dark;
      }

      .url-container {
        display: flex;
        justify-content: space-between;
        border: 1px solid #eaeaea;
        border-radius: 6px;
        overflow: hidden;
        .url {
          padding: 0.5rem;
          color: $dark;
          text-decoration: underline;
        }

        button {
          background-color: $dark;
          border-radius: 0 !important;
          color: white;
          padding: 0 0.5rem;
        }
      }

      p.msg {
        padding: 0.5rem 0;
        color: $green;
      }
    }

    .designs-container {
      display: flex;
      width: 100%;
      flex-wrap: wrap;

      .product-container {
        width: 20%;
        padding: 1em;
        min-width: 19em;
        margin: 0 auto;

        .product-wrapper {
          height: 100%;
          min-height: 315px;
          display: flex;
          flex-direction: column;
          align-items: center;
          border: 1px solid $gray;
          border-radius: 1em;

          p {
            text-transform: uppercase;
            color: $gray;
            font-weight: bold;
          }
        }
      }
    }

    .buttons-container {
      display: flex;
      justify-content: space-evenly;
      margin-left: auto;
      padding: 1rem 0;
      gap: 1rem;

      .btn {
        background: $dark;
        color: white;
        border-radius: 6px;
        padding: 0.5rem 1rem;
        outline: none;
        cursor: pointer;
        font-family: "SlateStd", Helvetica, Arial;

        &#send-quote-btn {
          font-size: 16px;
          padding: 0.75rem 2rem;
        }

        &.confirm {
          display: flex;
          align-items: center;
          background: $dark;
          color: white;
          text-transform: capitalize;
        }

        &.cancel {
          color: $grey-dark;
          background: none;
          &:hover {
            text-decoration: underline;
          }
        }

        &.white-btn {
          background: #fff;
          box-shadow: 0 0 10px -2px #0000004d;
          color: $dark;
          &:hover {
            color: #fff;
            background: $dark;
          }
        }
        &.black-btn {
          color: #fff;
          background-color: $dark;
          border-color: #fff;
          &:hover {
            color: $dark;
            background-color: #fff;
            border: 1px solid $dark !important;
            border-color: $dark;
          }
        }

        &:disabled {
          background: $grey-light;
          color: $dark;
          cursor: not-allowed !important;
        }

        @media screen and (max-width: 1200px) {
          margin-right: 0;
          margin: auto;
        }
      }
    }

    @media screen and (max-width: 1024px) {
      width: 50%;
    }
  }
}
</style>
